import React from 'react';
import './AccentedText.scss';

export const AccentedText = ({ children }) => {
    if (!children) {
        return <></>;
    }
    const textParts = children.split(`**`);

    return (
        <>
            {textParts.map((part, idx) => {
                if (idx % 2 === 0) {
                    return (
                        <React.Fragment key={`title-${idx}`}>
                            {part}
                        </React.Fragment>
                    );
                }
                return (
                    <span key={`title-${idx}`} className="accent">
                        {part}
                    </span>
                );
            })}
        </>
    );
};
